<template>
  <v-window v-model="tab">
    <v-window-item>
      <setting ref="tab0" :open-tab="openTab"/>
    </v-window-item>
    <v-window-item>
      <update ref="tab1" :open-tab="openTab"/>
    </v-window-item>
  </v-window>
</template>

<script>
import Setting from "./Setting";
import Update from "./Update";

export default {
  name: "Main",
  components: {Update, Setting},
  data() {
    return {
      loading: true,
      tab: 0,
    };
  },
  methods: {
    openTab(tab) {
      this.tab = tab
      let t = this.$refs[`tab${tab}`]
      if (t) return t.onTab()
    },
  },
}
</script>

<style scoped>

</style>